import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import {
  GenerateEpcRequest,
  GenerateEpcResponse,
  DecodeProductIdentifierParams,
  DecodeProductIdentifierResponse,
} from 'src/types/productIdentifier';

export const productAPI = createApi({
  reducerPath: 'productAPI',
  baseQuery: axiosBaseQueryWithReauth({
    baseUrl: process.env.REACT_APP_API_URL
  }),
  endpoints: (builder) => ({
    generateEpc: builder.mutation<GenerateEpcResponse, GenerateEpcRequest>({
      query: (payload) => ({
        url: 'Commissions/generate-epc',
        method: 'POST',
        body: payload
      })
    }),

    decodeProductIdentifier: builder.query<DecodeProductIdentifierResponse, DecodeProductIdentifierParams>({
      query: (params) => ({
        url: 'Products/decodeProductIdentifier',
        method: 'GET',
        params
      })
    })
  })
});

export const {
  useGenerateEpcMutation,
  useLazyDecodeProductIdentifierQuery
} = productAPI;